<template>
  <div class="__wrapper" v-if="!showModal">
    <div class="__head" :style="{
      'background-image': user.cover_picture
        ? 'url(' + $fullUrl('images/covers/' + user.cover_picture) + ')'
        : false,
    }"></div>
    <div class="__body">
      <!-- Project -->
      <div class="__container" v-if="proj">
        <div class="__section-center">
          <div class="section-center__layout">
            <div class="layout__left">
              <div class="__card lesss">
                <div class="contact-card">
                  <div class="section">
                    <router-link to="/profile/consultant">
                      <img v-if="user.profile" :src="$fullUrl('images/profiles/' + user.profile)" />
                      <img v-else src="@/assets/avatar.png" alt />
                    </router-link>
                    <router-link to="/profile/consultant">
                      <h2>{{ user.names | validate }}</h2>
                    </router-link>
                    <label>{{ user.job | validate }}</label>
                    <span>{{ user.location | validate }}</span>
                  </div>
                  <div class="sec" v-if="user.available !== '' && !isCustomer">
                    <label v-if="user.available_from &&
                      user.available_from !== '0000-00-00'
                      ">{{ user.available | validate }}</label>
                    <span v-if="user.available_from &&
                      user.available_from !== '0000-00-00'
                      ">{{ user.available_from | formatDate | validate }}</span>

                    <label v-else>Currently unavailable</label>
                  </div>
                </div>
              </div>
              <div class="__suggestion-box">
                <div class="__body">
                  <div class="vertical">
                    <router-link :to="{ name: 'settings', params: { tab: 'terms' } }">
                      <span>Terms & Conditions</span>
                    </router-link>
                    <img src="../assets/icons/stamp.svg" />
                  </div>
                </div>
              </div>
            </div>
            <div class="layout__right">
              <div class="__content-container">
                <div class="not-user-info-widget">
                  <img v-if="issuer.profile_picture" :src="$fullUrl('images/profiles/' + issuer.profile_picture)" />
                  <img v-else src="@/assets/avatar.png" />
                  <div class="content">
                    <router-link :to="{ name: 'profile-view', params: { id: issuer.id } }">
                      <span class="__colored">
                        {{
                          (issuer.first_name + " " + issuer.last_name)
                          | validate
                        }}
                      </span>
                    </router-link>
                    <span class="text">invited you to this project</span>
                  </div>
                </div>
                <div class="__card">
                  <div class="__tile">
                    <div class="name">{{ proj.name | validate }}</div>
                  </div>
                  <div class="__card-wrap">
                    <div class="column">
                      <h2 class="titlee">Company</h2>
                      <p>{{ proj.company.name | validate }}</p>

                      <h2 class="titlee">Time frame</h2>
                      <p class="date" v-if="proj.from">
                        <span style="margin-right: 4px">
                          {{ proj.from | formatDate | validate }}
                        </span>
                        <span v-if="proj.to">to {{ proj.to | formatDate | validate }}</span>
                      </p>

                      <h2 class="titlee" v-if="proj.location">Location</h2>
                      <p v-if="proj.location">{{ proj.location | validate }}</p>

                      <h2 class="titlee" v-if="proj.description">
                        Description
                      </h2>
                      <p v-if="proj.description" v-html="proj.description"></p>

                      <h2 class="titlee" v-if="proj.members.length > 0">
                        Members
                      </h2>
                      <div class="___members" v-if="proj.members.length > 0">
                        <div class="___member" v-for="(person, i) in proj.members" :key="i">
                          <img :src="$fullUrl(
                            'images/profiles/' + person.profile_picture
                          )
                            " />
                          <span>
                            {{
                              (person.first_name + " " + person.last_name)
                              | validate
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="__aligned">
                  <app-dialog title="Project Invitation" ask="Are you sure you want to accept this project invitation?"
                    yesText="Accept" noText="Cancel" yesBtnClass="btn-default" @onComfirm="acceptProjectOnly()">
                    <button class="btn-accept-only">Accept Only</button>
                  </app-dialog>
                  <app-dialog title="Project Invitation"
                    ask="Are you sure you want to accept this project invitation and add to your project list?"
                    yesText="Accept" noText="Cancel" yesBtnClass="btn-default" @onComfirm="showDetails()">
                    <button class="btn">Accept and Add Your Project</button>
                  </app-dialog>
                  <button class="decline" @click="declineNotification()">
                    I don’t recognise this
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="__section-right"></div>
      </div>
      <!-- Employment -->
      <div class="__container" v-else-if="employ">
        <div class="__section-center">
          <div class="section-center__layout">
            <div class="layout__left">
              <div class="__card lesss">
                <div class="contact-card">
                  <div class="section">
                    <router-link to="/profile/consultant">
                      <img v-if="user.profile" :src="$fullUrl('images/profiles/' + user.profile)" />
                      <img v-else src="@/assets/avatar.png" />
                    </router-link>
                    <router-link to="/profile/consultant">
                      <h2>{{ user.names | validate }}</h2>
                    </router-link>
                    <label>{{ user.job | validate }}</label>
                    <span>{{ user.location | validate }}</span>
                  </div>
                  <div class="sec" v-if="user.available !== '' && !isCustomer">
                    <label v-if="user.available_from &&
                      user.available_from !== '0000-00-00'
                      ">{{ user.available | validate }}</label>
                    <span v-if="user.available_from &&
                      user.available_from !== '0000-00-00'
                      ">{{ user.available_from | formatDate | validate }}</span>

                    <label v-else>Currently unavailable</label>
                  </div>
                </div>
              </div>
              <div class="__suggestion-box">
                <div class="__body">
                  <div class="vertical">
                    <router-link :to="{ name: 'settings', params: { tab: 'terms' } }">
                      <span>Terms & Conditions</span>
                    </router-link>
                    <img src="../assets/icons/stamp.svg" />
                  </div>
                </div>
              </div>
            </div>
            <div class="layout__right">
              <div class="__content-container">
                <div class="not-user-info-widget">
                  <img :src="$fullUrl('images/profiles/' + issuer.profile_picture)" />
                  <div class="content">
                    <router-link :to="{ name: 'profile-view', params: { id: issuer.id } }">
                      <span class="__colored">
                        {{
                          (issuer.first_name + " " + issuer.last_name)
                          | validate
                        }}
                      </span>
                    </router-link>
                    <span class="text">invited you to this employment</span>
                  </div>
                </div>
                <div class="__card">
                  <div class="__tile">
                    <div class="name">{{ employ.company.name | validate }}</div>
                  </div>
                  <div class="__card-wrap">
                    <div class="column">
                      <h2 class="titlee">Time frame</h2>
                      <p class="date" v-if="employ.from">
                        <span style="margin-right: 4px">
                          {{ employ.from | formatDate | validate }}
                        </span>
                        <span v-if="employ.to">to {{ employ.to | formatDate | validate }}</span>
                      </p>

                      <h2 class="titlee" v-if="employ.location">Location</h2>
                      <p v-if="employ.location">
                        {{ employ.location | validate }}
                      </p>

                      <h2 class="titlee" v-if="employ.description">
                        Description
                      </h2>
                      <p v-if="employ.description" v-html="employ.description"></p>

                      <h2 class="titlee" v-if="employ.members.length > 0">
                        Members
                      </h2>
                      <div class="___members" v-if="employ.members.length > 0">
                        <div class="___member" v-for="(person, i) in employ.members" :key="i">
                          <img :src="$fullUrl(
                            'images/profiles/' + person.profile_picture
                          )
                            " />
                          <span>
                            {{
                              (person.first_name + " " + person.last_name)
                              | validate
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="__aligned">
                  <app-dialog title="Project Invitation" ask="Are you sure you want to accept this employment invitation?"
                    yesText="Accept" noText="Cancel" yesBtnClass="btn-default" @onComfirm="acceptEmploymentOnly()">
                    <button class="btn-accept-only">Accept Only</button>
                  </app-dialog>
                  <app-dialog title="Employment Invitation"
                    ask="Are you sure you want to accept this employment invitation and add to your employment list?"
                    yesText="Accept" noText="Cancel" yesBtnClass="btn-default" @onComfirm="showDetails()">
                    <button class="btn">Accept invitation</button>
                  </app-dialog>
                  <button class="decline" @click="declineNotification()">
                    I don’t recognise this
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="__section-right"></div>
      </div>
      <!-- When no project or emplyment found -->
      <div class="empty-widget" v-else>
        <h1>Notification data not found</h1>
      </div>
      <div class="floater">
        <chat></chat>
      </div>
    </div>
  </div>
  <div class="wrapper" v-else>
    <div class="__body">
      <div class="accept-envitation-widget">
        <!-- Project form -->
        <div class="form-widget" v-if="proj">
          <div class="logo">
            <img src="../assets/images/logo/new_logo.svg" alt />
          </div>
          <div class="title">Describe your participation in the project…</div>
          <div class="input-widget">
            <div class="input-group col-2" style="margin-bottom: 20px">
              <div class="input-wrapper">
                <label class="input-label">Project Name</label>
                <input type="text" disabled class="dark" v-model="proj.name" placeholder="Project Name" />
              </div>
              <div class="input-wrapper">
                <label class="input-label">Company Name</label>
                <input type="text" disabled class="dark" v-model="proj.company.name" placeholder="Company Name" />
              </div>
            </div>
            <div class="input-group col-4" style="margin-bottom: 20px">
              <div class="input-wrapper">
                <label class="input-label">Role</label>
                <input type="text" class="light" v-model="proj.role" placeholder="Role" />
              </div>
              <div class="input-wrapper">
                <label class="input-label">Time frame</label>
                <div class="range-date">
                  <div class="check-label">
                    <label for="curr">Current Project</label>
                    <input v-model="proj.is_current_project" @change="setCurrentTime" type="checkbox" name="curr"
                      id="curr" />
                  </div>
                  <datepicker :monday-first="true" placeholder="Start Date" v-model="proj.from"
                    input-class="date-field-input" wrapper-class="date-field"></datepicker>
                  <datepicker :monday-first="true" placeholder="End Date" :disbled="proj.is_current_project"
                    v-model="proj.to" input-class="date-field-input" wrapper-class="date-field"></datepicker>
                </div>
              </div>
              <div class="input-wrapper">
                <label class="input-label">Location</label>
                <map-helper v-model="proj.address"></map-helper>
              </div>
            </div>
            <div class="input-group col-1">
              <div class="input-wrapper">
                <label class="input-label">Enter description</label>
                <html-editor v-model="proj.description" id="edit-proj-descr" />
              </div>
            </div>
          </div>
          <div class="widget-options">
            <button class="btn-submit" @click="acceptProjet()">Submit</button>
          </div>
        </div>
        <!-- Employment form -->
        <div class="form-widget" v-else-if="employ">
          <div class="logo">
            <img src="../assets/images/logo/new_logo.svg" alt />
          </div>
          <div class="title">
            Describe your participation in the employment…
          </div>
          <div class="input-widget">
            <div class="input-group col-3" style="margin-bottom: 25px">
              <div class="input-wrapper">
                <label class="input-label">Company Name</label>
                <input type="text" :disabled="true" class="dark" v-model="employ.company.name" style="width: 300px"
                  placeholder="Company Name" />
              </div>
              <div class="input-wrapper">
                <label class="input-label">Location</label>
                <map-helper v-model="employ.address"></map-helper>
              </div>
            </div>
            <div class="input-group col-2" style="margin-bottom: 25px">
              <div class="input-wrapper">
                <label class="input-label">Role</label>
                <input type="text" class="light" v-model="employ.role" placeholder="Role" />
              </div>
              <div class="input-wrapper">
                <label class="input-label">Time Frame</label>
                <div class="range-date">
                  <div class="check-label">
                    <label for="currr">Current Employment</label>
                    <input type="checkbox" name="curr" id="currr" />
                  </div>
                  <datepicker :monday-first="true" placeholder="Start Date" v-model="employ.from"
                    input-class="date-field-input" wrapper-class="date-field"></datepicker>
                  <datepicker :monday-first="true" :disabled="employ.current" placeholder="End Date"
                    input-class="date-field-input" v-model="employ.to" wrapper-class="date-field"></datepicker>
                </div>
              </div>
            </div>
            <div class="input-group col-1">
              <div class="input-wrapper">
                <label class="input-label">Enter employment description</label>
                <html-editor v-model="employ.description" id="edit-empoy-descr" />
              </div>
            </div>
          </div>
          <div class="widget-options">
            <button class="btn-submit" @click="acceptEmploy()">Submit</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import appDialog from "@/components/Dialog/AppDialog.vue";
import { mapGetters } from "vuex";
import { eventBus } from "../main";
import Datepicker from "vuejs-datepicker";
import Chat from "@/components/Chat/Chat";
import HtmlEditor from "@/components/helper/HtmlEditor.vue";
export default {
  name: "NotificationDetail",
  data() {
    return {
      showModal: false,
      object: {
        name: "",
        role: "",
        company: "",
        from: "",
        to: "",
        description: "",
        country: 0,
        city: 0,
        address: "",
      },
    };
  },
  components: {
    appDialog,
    Datepicker,
    Chat,
    HtmlEditor,
  },
  computed: {
    ...mapGetters([
      "getCountries",
      "getCities",
      "getNotification",
      "getMeProfile",
    ]),
    latests() {
      return this.getNotification.issuer.bestprojects;
    },
    proj() {
      if (this.getNotification.project) {
        return this.getNotification.project;
      } else {
        return null;
      }
    },
    employ() {
      if (this.getNotification.employment) {
        return this.getNotification.employment;
      } else {
        return null;
      }
    },
    issuer() {
      return this.getNotification.issuer;
    },
    isCustomer() {
      return this.getMeProfile.user.account_type == 2;
    },
    user() {
      let job = "";
      let country = "";
      let city = "";
      if (this.getMeProfile.employment.length > 0)
        job = this.getMeProfile.employment[0].company.name;
      if (this.getMeProfile.profile.location) {
        if (this.getMeProfile.profile.location.country_id)
          country = this.getMeProfile.profile.location.country.name;
        if (this.getMeProfile.profile.location.city_id)
          city = this.getMeProfile.profile.location.city.name;
      }
      return {
        profile: this.getMeProfile.user.profile_picture,
        names:
          this.getMeProfile.user.first_name +
          " " +
          this.getMeProfile.user.last_name,
        email: this.getMeProfile.user.email,
        phone: this.getMeProfile.profile.phone,
        available: "Available from",
        available_from: this.getMeProfile.profile.available_from,
        city: city,
        country: country,
        cover_picture: this.getMeProfile.profile.cover_photo,
        location: city + (country === "" ? "" : ", " + country),
        job: job,
      };
    },
  },
  mounted() {
    this.$store.dispatch("GET_COUNTRIES");
    this.$store.dispatch("GET_ME_PROFILE_DATA");
    this.$store.dispatch("GET_NOTIFICATION_DATA", {
      id: this.$route.params.id,
    });
    if (this.$route.params.direct === "direct") this.showModal = true;
  },
  methods: {
    acceptEmploymentOnly() {
      let vm = this;
      vm.showModal = false;
      vm.employ.not_id = vm.$route.params.id;
      vm.$store.dispatch("ACCEPT_ONLY_EMPLOYMENT", vm.employ);
    },
    acceptProjectOnly() {
      let vm = this;
      vm.showModal = false;
      vm.getNotification.project.not_id = vm.$route.params.id;
      vm.$store.dispatch("ACCEPT_ONLY_PROJECT", vm.getNotification.project);
    },
    setCurrentTime() {
      this.proj.to = "";
    },
    showDetails() {
      this.showModal = true;
    },
    acceptProjet() {
      let vm = this;
      vm.showModal = false;
      vm.getNotification.project.not_id = vm.$route.params.id;
      vm.$store.dispatch("ALLOW_TOBE_MEMBER", vm.getNotification.project);
    },
    acceptEmploy() {
      let vm = this;
      vm.showModal = false;
      vm.employ.not_id = vm.$route.params.id;
      vm.$store.dispatch("ALLOW_TOBE_EMPLOYMENT_MEMBER", vm.employ);
    },
    declineNotification() {
      this.$store.dispatch("DECLINE_TOBE_MEMBER", {
        id: this.$route.params.id,
      });
      this.$router.push({ name: "notifications" });
    },
  },
};
</script>

<style lang="scss" scoped>
a:hover,
a {
  text-decoration: none !important;
}

.h2 {
  font-size: 12px;
  font-weight: lighter;
  color: #6e6e6e;
  margin-top: 10px !important;
}

.__card {
  background: #fff;
  border-radius: 3px;
}

.__wrapper {
  background: rgba(239, 239, 239, 0.49);
  min-height: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;

  .__head {
    height: 90px;
    margin-top: 55px;
    background-image: url("../assets/images/backgrounds/wallpaper.svg");
    background-size: cover;

    @media (min-width: 300px) and (max-width: 630px) {
      display: none;
    }
  }

  .__body {
    height: calc(100vh - 90px);
    overflow-y: auto;

    .empty-widget {
      text-align: center;
      margin-top: 40px;
    }

    .__container {
      margin: 0 auto;
      width: 800px;
      padding-top: 17px;

      @media (min-width: 300px) and (max-width: 630px) {
        grid-template-columns: 1fr;
        width: 90%;
        padding-top: 70px;
      }

      .__section-center {
        min-width: 0;

        .section-center__layout {
          display: grid;
          grid-column-gap: 10px;
          grid-template-columns: 1fr 4fr;

          @media (min-width: 300px) and (max-width: 630px) {
            grid-template-columns: 100%;
          }

          .layout__left {
            min-width: 0;

            @media (min-width: 300px) and (max-width: 630px) {
              display: none;
            }

            h2 {
              color: #535353;
              margin-top: 20px;
              margin-left: 10px;
              font-size: 23px;
            }

            a:hover {
              text-decoration: none !important;
            }

            .item-row {
              padding: 10px 20px;

              &:hover {
                background: #1890a9;
              }

              img {
                margin-right: 10px;
              }

              span {
                color: #797979;
                font-size: 14px;
                font-weight: normal;
              }

              .fin {
                float: right;
                font-weight: bold;
                margin-top: 2px;
                margin-right: 0 !important;
                font-size: 12px;
              }
            }

            .item-row-active {
              background: #1890a9;
            }

            .__body {
              display: flex;
              flex-direction: column;
              padding: 10px;

              h3 {
                font-size: 14px;
                color: #000000;
                font-weight: bolder;
                text-align: center;
                margin-top: 10px;
                margin-bottom: 30px;
              }

              .__item {
                margin-bottom: 10px;
                cursor: pointer;
                display: flex;
                justify-content: space-between;
                padding-left: 20px;

                label {
                  color: #1885ad;
                  font-size: 14px;
                  cursor: pointer;
                  margin-right: 10px;
                  font-weight: normal;
                }
              }
            }

            .contact-card {
              display: flex;
              flex-direction: column;

              .section {
                width: 100%;
                display: flex;
                padding: 10px 0;
                justify-content: center;
                align-items: center;
                border-bottom: 2px solid #f5f5f5;
                flex-direction: column;

                img {
                  width: 60px;
                  height: 60px;
                  cursor: pointer;
                  margin-top: 0px;
                  border-radius: 100%;
                  object-fit: cover;
                }

                h2 {
                  font-weight: normal;
                  color: #000000 !important;
                  line-height: 12px;
                  text-align: center;
                  margin: 5px 0 !important;
                  font-size: 15px;
                }

                span {
                  color: #4e4e4e;
                  text-align: center;
                  margin-top: 5px;
                  font-size: 14px;
                }

                label {
                  font-size: 14px;
                  text-align: center;
                  margin-top: 10px;
                  color: #808080;
                }
              }

              .sec {
                width: 100%;
                display: flex;
                padding: 10px 10px;
                justify-content: center;
                align-items: center;
                flex-direction: column;

                span {
                  color: #808080;
                  text-align: center;
                  font-size: 13px;
                }
              }
            }

            .__suggestion-box {
              padding: 10px;

              .__body {
                margin-top: 0px;
                background: transparent;

                .__item {
                  display: flex;
                  margin-bottom: 20px;
                  flex-direction: row;

                  img,
                  .__logo {
                    width: 25px;
                    height: 25px;
                    border-radius: 100%;
                  }

                  .__logo {
                    background: #1885ad;
                    padding: 0 !important;
                    box-sizing: border-box;
                    display: flex;
                    justify-content: center;
                    align-items: center;

                    span {
                      color: #fff;
                      font-size: 42px;
                      margin: 0 0 12px 12px;
                      font-weight: normal;
                    }
                  }

                  .__centered {
                    display: flex;
                    flex-direction: row;
                    width: 100%;
                    margin-left: 10px;
                    justify-content: space-between;

                    .__text {
                      display: flex;
                      flex-direction: column;

                      h3 {
                        margin-bottom: 0;
                        font-weight: normal;
                        font-size: 13px;
                        cursor: pointer;
                      }

                      span {
                        margin-top: -5px;
                        font-size: 10px;
                      }

                      .__greyed {
                        color: #000;
                        cursor: default;
                      }

                      label {
                        font-size: 11px;
                      }
                    }

                    img {
                      padding: 5px;
                      border-radius: 100px;
                      width: 20px;
                      height: 20px;
                      background: #ececef;
                    }
                  }
                }

                .vertical {
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  align-items: center;

                  span {
                    color: #959595;
                    font-size: 10px;
                    text-decoration: underline;
                    cursor: pointer;
                    margin-bottom: 10px;
                    font-weight: normal;
                  }

                  h1 {
                    color: #959595;
                    font-size: 19px;
                    opacity: 0.6;
                    font-weight: normal;
                  }

                  label {
                    font-size: 11px;
                    font-weight: normal;
                    margin-top: 0px;
                    color: #959595;
                  }

                  img {
                    margin-top: 0px;
                  }
                }
              }
            }
          }

          .layout__right {
            min-width: 0;

            .__content-container {
              position: relative;

              .not-user-info-widget {
                display: flex;
                align-items: center;
                margin-bottom: 15px;
                padding-left: 20px;

                @media (min-width: 300px) and (max-width: 630px) {
                  padding-left: 0px;
                }

                img {
                  width: 40px;
                  height: 40px;
                  object-fit: cover;
                  border-radius: 50%;
                  margin-right: 15px;
                }

                .content {
                  font-size: 15px;

                  a {
                    margin-right: 5px;
                  }

                  span.text {
                    font-style: italic;
                  }
                }
              }

              .__card {
                background: #fff;
                border-radius: 3px;
                padding-bottom: 20px;
                margin-bottom: 10px;

                .__tile {
                  display: flex;
                  margin-top: 0px;
                  margin-bottom: 10px;
                  justify-content: space-between;

                  .name {
                    font-size: 19px;
                    color: #676767;
                    font-weight: 800;
                  }

                  .date {
                    font-size: 14px;
                    color: #707070;
                  }
                }

                .__card-wrap {
                  display: flex;
                  flex-direction: column;

                  .column {
                    display: flex;
                    flex-direction: column;

                    .titlee {
                      font-size: 15px;
                      color: #000000;
                      font-weight: 800;
                      margin-bottom: 10px;
                    }

                    p {
                      font-size: 14px;
                      color: #6e6e6e;
                      margin-bottom: 25px;
                    }

                    .___members {
                      margin-top: 10px;
                      display: flex;

                      .___member {
                        background: #999999 0% 0% no-repeat padding-box;
                        display: flex;
                        padding: 4px 12px 4px 5px;
                        opacity: 0.8;
                        justify-content: center;
                        align-items: center;
                        border-radius: 20px;
                        margin-right: 10px;

                        span {
                          color: #fff;
                          font-size: 12px;
                        }

                        img {
                          width: 30px;
                          height: 30px;
                          margin-right: 10px;
                          border-radius: 100%;
                          object-fit: cover;
                        }
                      }
                    }
                  }
                }
              }

              .__aligned {
                display: flex;
                margin-top: 20px;
                align-items: center;
                padding-left: 20px;

                @media (min-width: 300px) and (max-width: 630px) {
                  padding-left: 0px;
                }

                .btn-accept-only {
                  color: #fff;
                  outline: none;
                  font-size: 12px;
                  border: none;
                  width: 186px;
                  height: 38px;
                  background: #1885ad;
                  border-radius: 6px;
                  font-weight: 800;
                  margin-right: 10px;
                }

                .btn {
                  color: #fff;
                  outline: none;
                  font-size: 12px;
                  border: none;
                  width: 186px;
                  height: 38px;
                  background: transparent linear-gradient(260deg, #1885ad 0%, #00a5a6 100%) 0% 0% no-repeat padding-box;
                  border-radius: 6px;
                  font-weight: 800;
                  margin-right: 10px;
                }

                .decline {
                  font-family: "Nunito", sans-serif;
                  font-size: 12px;
                  height: 25px;
                  margin-left: 20px;
                  font-weight: normal;
                  font-stretch: normal;
                  font-style: normal;
                  line-height: 1.42;
                  letter-spacing: 0.36px;
                  text-align: left;
                  color: #1885ad;
                  font-weight: 800;
                }
              }
            }
          }
        }
      }

      .__section-right {
        min-width: 0;
      }
    }

    .floater {
      position: fixed;
      bottom: 0px;
      right: 10px;
    }
  }
}

.__colored {
  color: #1890a9;
}

.__green {
  color: #1ba5a4;
}

.__white {
  color: #ffffff;
}

.__v-space {
  margin-top: 15px !important;
}

.error {
  border: 1px solid maroon !important;
}

.__card {
  background: #fff;
  padding: 20px;
}

.less {
  padding: 0 !important;
  border-radius: 5px;
  margin-bottom: 10px;
  overflow: hidden;
}

.lesss {
  padding: 0 !important;
  border-radius: 5px;
  margin-bottom: 10px;
}

.greyed {
  background: #f8f8f8;
}

.__body {
  height: 100vh;
  overflow-y: auto;
  background: #efefef;

  .accept-envitation-widget {
    padding-bottom: 35px;
    padding-top: 90px;
    width: 800px;
    margin: 0 auto;

    @media (min-width: 300px) and (max-width: 630px) {
      padding-top: 51px;
    }

    .form-widget {
      background: #fff;
      border-radius: 5px;
      display: flex;
      align-items: center;
      flex-direction: column;
      $column-space: 20px;
      width: 100%;
      padding-top: $column-space;

      @media (min-width: 300px) and (max-width: 630px) {
        width: 100%;
      }

      .logo {
        margin-bottom: 30px;

        img {
          width: 80px;
        }
      }

      .title {
        color: #1ba5a4;
        font-size: 30px;
        font-family: "Nunito", sans-serif;
        margin-bottom: $column-space;
        text-align: center;
        padding: 0px 30px;
      }

      .input-widget {
        width: 100%;
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 30px;
        padding-right: 30px;
        margin-bottom: $column-space;

        .input-group {
          display: grid;
          grid-column-gap: 20px;

          .input-wrapper {
            @media (min-width: 300px) and (max-width: 630px) {
              margin-bottom: 15px;
            }

            .input-label {
              display: block;
              font-family: "Nunito", sans-serif;
              margin-bottom: 5px;
            }

            input.dark {
              height: 47px;
              width: 100%;
              background: #efefef 0% 0% no-repeat padding-box;
              border-radius: 5px;
              padding: 0px 20px;
              color: #000;
              font-family: "Nunito", sans-serif;
              outline: none;
            }

            input.dark::placeholder {
              font-weight: 800;
            }

            input.light,
            select {
              height: 47px;
              width: 100%;
              background: #ffffff 0% 0% no-repeat padding-box;
              box-shadow: 0px 2px 6px #00000029;
              border: 1px solid #ccc;
              border-radius: 5px;
              padding: 0px 20px;
              color: #000;
              font-family: "Nunito", sans-serif;
              outline: none;
            }

            textarea {
              background: #ffffff 0% 0% no-repeat padding-box;
              box-shadow: 0px 3px 3px #00000029;
              border: 1px solid #ccc;
              border-radius: 5px;
              padding: 10px;
              outline: none;
              width: 100%;
            }

            .range-date {
              display: grid;
              grid-column-gap: 5px;
              grid-template-columns: auto auto;
              height: 47px;
              width: 100%;
              background: #ffffff 0% 0% no-repeat padding-box;
              box-shadow: 0px 2px 6px #00000029;
              border: 1px solid #ccc;
              border-radius: 5px;
              padding: 4px 0px;
              padding-right: 10px;
              position: relative;

              .check-label {
                position: absolute;
                z-index: 999;
                top: -19px;
                right: 0px;
                display: flex;
                justify-content: flex-end;
                align-items: center;

                label {
                  width: calc(100% - 10px);
                  text-align: right;
                }

                input {
                  width: 10px;
                  margin-left: 5px;
                }
              }

              .date-field {
                background: #efefef;
                margin-left: 5px;
                height: 36px;
                border-radius: 5px;
                padding: 8px 10px;
                width: 100%;

                .date-field-input {
                  width: 100% !important;
                }
              }
            }
          }
        }

        .input-group.col-1 {
          grid-template-columns: auto;
        }

        .input-group.col-2 {
          grid-template-columns: auto auto;

          @media (min-width: 300px) and (max-width: 630px) {
            grid-template-columns: auto;
            margin-bottom: 15px;
          }
        }

        .input-group.col-3 {
          grid-template-columns: auto auto auto;

          @media (min-width: 300px) and (max-width: 630px) {
            grid-template-columns: auto;
            margin-bottom: 15px;
          }
        }

        .input-group.col-4 {
          grid-template-columns: auto auto auto auto;

          @media (min-width: 300px) and (max-width: 630px) {
            grid-template-columns: auto;
            margin-bottom: 15px;
          }

          input,
          select {
            width: 147px;
          }
        }
      }

      .widget-options {
        margin-bottom: $column-space;

        .btn-submit {
          width: 234px;
          height: 48px;
          background: #1885ad 0% 0% no-repeat padding-box;
          border-radius: 5px;
          color: #fff;
          font-family: "Nunito", sans-serif;
          font-weight: 800;
        }
      }
    }
  }
}
</style>
